var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPlayIcon = function SvgVideoPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5574FF",
    d: "M7.333.5a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0-6.5-6.5m2.275 6.919-3 2a.54.54 0 0 1-.275.081.5.5 0 0 1-.237-.056A.5.5 0 0 1 5.833 9V5a.5.5 0 0 1 .263-.444.52.52 0 0 1 .512.025l3 2a.5.5 0 0 1 0 .838"
  })));
};
export default SvgVideoPlayIcon;